import { type FC } from "react";
import { TableCell, Typography } from "@mui/material";
import type { CustomerSummary } from "../customerSummariesApi";
import { formatDatePl } from "../formatDatePl";

interface Props {
  client: CustomerSummary;
}

/** Last meeting (bold), last Przezmorze note and last TravelPay note dates, one per line. */
const LastActivityCell: FC<Props> = ({ client }) => (
  <TableCell data-testid="last-activity-cell">
    <Typography variant="body2" sx={{ fontWeight: 700 }} title="Ostatnie spotkanie">
      {formatActivityDate(client.meetingDate)}
    </Typography>
    <Typography variant="body2" title="Ostatnia notatka Przezmorze">
      {formatActivityDate(client.lastNotePrzezmorzeDate)}
    </Typography>
    <Typography variant="body2" title="Ostatnia notatka TravelPay">
      {formatActivityDate(client.lastNoteTravelPayDate)}
    </Typography>
  </TableCell>
);

function formatActivityDate(value: string | null): string {
  return value ? formatDatePl(value) : "-";
}

export default LastActivityCell;
